import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useConfig from "../../hooks/useConfig";
import { InfoRounded } from "@mui/icons-material";

// https://locusrobotics.atlassian.net/browse/HUB-2477
export const AnalyticsDisruptionBanner = () => {
  const theme = useTheme();
  const { navType } = useConfig();

  const bannerMessage = "Data availability for the Executive Summary > Missions report is currently limited to April 1st 2025. We are backfilling the data to September 1st 2024, and this is expected to complete on October 28th.";

  return (
    <Box
      id="globalAnalyticsDisruptionBanner"
      sx={{
        py: 1,
        pr: 1,
        mb: 1,
        backgroundColor: theme.palette.background.paper,
        display: "flex",

        color:
          navType === "dark"
            ? theme.palette.text.primary
            : theme.palette.text.primary
      }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginRight: "10px",
          marginLeft: "10px",
        }}
      >
        <InfoRounded stroke={1.5} size="20px" />
      </div>
      <Typography variant="subtitle1" color="inherit">
        {bannerMessage}
      </Typography>
    </Box>
  );
};
